module.exports = __webpack_public_path__ + "static/beauty4-d5828c8fd894aeed0786f75da87c84ee.jpg";